import { Typography, Paper, Tabs, Tab, Grid, Box, Button } from '@material-ui/core'
import React, { useState, useEffect, Dispatch } from 'react'
import { SubGroupsClient, SubGroupResponseDTO } from '../generated/ApiClient'
import { RouteComponentProps } from 'react-router'
import SubgroupForm from './SubgroupForm'
import { actionCreators as snackbar } from '../store/AlertSnackbarStore'
import { useDispatch } from "react-redux";
import SubgroupUsers from './SubgroupUsers'
import TabPanel from '../common/TabPanel'
import SubgroupModems from './SubgroupModems'
import CenteredProgress from '../common/CenteredLoader'

const AboutTabValue = 0;
const MembersTabValue = 1;
const ModemsTabValue = 2;

interface SubgroupData {
    name: string;
    externalId: string;
    organizationId: string;
}

export default function SubgroupDetails(props: RouteComponentProps<{ organizationId: string, subgroupId: string }>) {
    const [subgroupData, setSubgroupData] = useState<SubgroupData | 'Loading' | undefined>('Loading');
    const [value, setValue] = React.useState(0);
    const dispatch = useDispatch();

    function toViewData(subgroupData: SubGroupResponseDTO, organizationId: string) {
        return { name: subgroupData.name, externalId: subgroupData.externalId, organizationId }
    }

    function tabHandler(event: React.ChangeEvent<{}>, newValue: number) {
        setValue(newValue);
    };

    useEffect(() => {
        const fetchData = async () => {
            try {
                const selectedSubgroup = await new SubGroupsClient().get5(props.match.params.subgroupId);
                setSubgroupData(toViewData(selectedSubgroup, props.match.params.organizationId));
            }
            catch {
                setSubgroupData(undefined);
            }
        }
        fetchData();
    }, [props.match.params.organizationId, props.match.params.subgroupId])

    if (subgroupData === 'Loading')
        return <CenteredProgress />
    else if (subgroupData) {
        const subgroupId = subgroupData.externalId;
        const organizationId = subgroupData.organizationId;
        return (
            <>
                <Typography variant='h4' id="tabelLabel">{subgroupData.name}</Typography>
                <Paper square>
                    <Tabs
                        value={value}
                        onChange={tabHandler}
                        variant="scrollable"
                        scrollButtons="auto"
                    >
                        <Tab label="About" value={AboutTabValue} />
                        <Tab label="Members" value={MembersTabValue} />
                        <Tab label="Modems" value={ModemsTabValue} />
                    </Tabs>
                </Paper>
                <TabPanel value={value} index={MembersTabValue}>
                    <SubgroupUsers subgroupId={subgroupId} organizationId={organizationId}></SubgroupUsers>
                </TabPanel>
                <TabPanel value={value} index={ModemsTabValue}>
                    <SubgroupModems subgroupId={subgroupId} organizationId={organizationId}></SubgroupModems>
                </TabPanel>
                <TabPanel value={value} index={AboutTabValue}>
                    <SubgroupForm subgroupId={subgroupId} organizationId={organizationId}></SubgroupForm>
                </TabPanel>
            </>
        )
    } else {
        return (
            <>
                <Typography variant='h4' id="tabelLabel">Subgroup Not Found</Typography>
            </>
        )
    }
}